import { io } from 'socket.io-client';
import { getNotifURL } from './GeneralServices';

// Deliberately minimal: no presence heartbeat, no notification cache, no
// app-wide singleton kept alive across every route. Pages that want a live
// feel (Contact, Tickets) connect on mount and disconnect on unmount, so a
// socket only exists while one of those screens is actually open.
const SOCKET_IO_PATH = '/api/socket.io';

let socket = null;

function connect(studentId) {
  if (socket) return socket;
  socket = io(getNotifURL(), {
    path: SOCKET_IO_PATH,
    withCredentials: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 3000,
    transports: ['polling'],
    upgrade: false,
  });
  socket.on('connect', () => {
    socket.emit('join', { userId: String(studentId), userType: 'student' });
  });
  return socket;
}

function disconnect() {
  if (!socket) return;
  socket.disconnect();
  socket = null;
}

function on(event, cb) {
  if (!socket) return () => {};
  socket.on(event, cb);
  return () => socket?.off(event, cb);
}

const SocketService = { connect, disconnect, on };

export default SocketService;
